import { NavLink, useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Home, ShoppingCart, User } from "lucide-react";
import { useCart } from "@/lib/cart";

const tabs = [
  { to: "/", label: "Menu", icon: Home, id: "nav-menu" },
  { to: "/troli", label: "Pesanan", icon: ShoppingCart, id: "nav-pesanan" },
  { to: "/akaun", label: "Akaun", icon: User, id: "nav-akaun" },
];

export const PhoneFrame = ({ children }) => (
  <div className="min-h-screen w-full flex justify-center bg-[#FDFBF7] md:bg-[#3B0A0A] relative">
    <div aria-hidden className="hidden md:block fixed inset-0 pointer-events-none overflow-hidden">
      <img src="https://images.unsplash.com/photo-1677921755291-c39158477b8e?crop=entropy&cs=srgb&fm=jpg&q=60&w=1600" alt=""
        className="w-full h-full object-cover opacity-25 blur-2xl scale-110" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(59,10,10,0.35),rgba(59,10,10,0.92)_70%)]" />
      <div className="absolute left-10 bottom-10 hidden xl:block text-white/80">
        <p className="font-display text-3xl font-extrabold">Pokya</p>
        <p className="font-script text-amber-400 text-lg">Restaurant</p>
      </div>
    </div>
    <div data-testid="phone-frame" className="relative w-full md:max-w-md min-h-screen bg-[#FDFBF7] md:shadow-[0_0_80px_rgba(0,0,0,0.45)]">{children}</div>
  </div>
);

export default function CustomerShell() {
  const { count } = useCart();
  const { pathname } = useLocation();
  const outlet = useOutlet();
  return (
    <PhoneFrame>
      <div className="pb-24">
        <AnimatePresence mode="wait">
          <motion.div key={pathname} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}>
            {outlet}
          </motion.div>
        </AnimatePresence>
      </div>
      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full md:max-w-md bg-white/90 backdrop-blur-xl border-t border-slate-200 z-40" data-testid="bottom-nav">
        <div className="grid grid-cols-3 py-2">
          {tabs.map(({ to, label, icon: Icon, id }) => (
            <NavLink key={to} to={to} end data-testid={id}
              className={({ isActive }) => `relative flex flex-col items-center gap-1 py-1 pb-2 text-xs font-medium transition-colors ${isActive ? "text-[#B91C1C]" : "text-slate-500"}`}>
              {({ isActive }) => (
                <>
                  <span className="relative">
                    <Icon className="w-6 h-6" strokeWidth={isActive ? 2.4 : 1.8} fill={isActive && to === "/" ? "#B91C1C" : "none"} />
                    {to === "/troli" && count > 0 && (
                      <motion.span key={count} initial={{ scale: 0.4 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 500, damping: 14 }}
                        data-testid="cart-badge" className="absolute -top-2 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">{count}</motion.span>
                    )}
                  </span>
                  {isActive && <motion.span layoutId="nav-dot" className="absolute bottom-0 w-6 h-1 rounded-full bg-[#B91C1C]" />}
                  {label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </PhoneFrame>
  );
}
